/* eslint-disable react/function-component-definition */
import React from 'react';
import parse from 'html-react-parser';
import Tabs from 'react-bootstrap/Tabs';
import TabPane from 'react-bootstrap/TabPane';
import { IContentGroup } from '../../helpers/interfaces';

interface TabbedComponentProps {
  content: IContentGroup[]; // each content item must contain a unique id
  tabTitle?: string; // if needed pass tab title
  tabId: string; // pass a unique id for the whole tab
}

class TabbedComponent extends React.Component<TabbedComponentProps> {
  render() {
    const { content, tabTitle, tabId } = this.props;

    const tabsContent = (
      <Tabs
        defaultActiveKey={content[0].id}
        id={tabId}
        className="nav-underline">
        {content.map((tab) => (
          <TabPane
            key={tab.id}
            eventKey={tab.id}
            title={tab.title}>
            {tab.content}
          </TabPane>
        ))}
      </Tabs>
    );

    return tabTitle ? (
      <div className="table-nav-captioned">
        <h3 className="table-nav-caption">{parse(tabTitle)}</h3>
        {tabsContent}
      </div>
    ) : (
      tabsContent
    );
  }
}

export default TabbedComponent;
